import { createEvent } from './createEvent'

type SavedTrendProperties = {
  id: string
  name: string
  starred: boolean
}
export const savedTrendClicked = createEvent<SavedTrendProperties>(
  'Saved Trend Clicked',
)

type TrendClickedProperties = {
  fid: string
  savedTrend: SavedTrendProperties | undefined
}

type AddChartClickedProperties = TrendClickedProperties & {
  chartType: string
}

export const addChartClicked =
  createEvent<AddChartClickedProperties>('Add Chart Clicked')

export const saveTrendClicked =
  createEvent<TrendClickedProperties>('Save Trend Clicked')

export const shareTrendClicked = createEvent<TrendClickedProperties>(
  'Share Trend Clicked',
)
export const resetTrendClicked = createEvent<TrendClickedProperties>(
  'Reset Trend Clicked',
)
export const newTrendClicked =
  createEvent<TrendClickedProperties>('New Trend Clicked')
